import APIRequestState from '../_util/api-request';

class UserSchemeState extends APIRequestState {
  get url() { return '/me/referral/scheme'; }
  get method() { return 'GET'; }
  get singular() { return 'scheme'; }
  get plural() { return 'schemes'; }
}

export default UserSchemeState;



// WEBPACK FOOTER //
// ./spa/state/user/user-referral-scheme.jsx